import classNames from "classnames";
import React, { ReactElement } from "react";
import { UserEntity } from "../../../../application/domain/user/user-entity";

type Props = {
  user: UserEntity;
  confirmMessage: ReactElement;
  submitLabel: string;
  onSubmit: () => void;
  cancelLabel?: string;
  onCancel: () => void;
  isLoading: boolean;
};

export const ConfirmModalContentForUser: React.FC<Props> = ({
  user,
  confirmMessage,
  cancelLabel = "キャンセルする",
  onCancel,
  submitLabel,
  onSubmit,
  isLoading,
}) => {
  return (
    <>
      <section className="modal-card-body">
        <div className="field">{confirmMessage}</div>
        <div className="field">
          <label className="label">ユーザーID</label>
          {user.id}
        </div>
        <div className="field">
          <label className="label">アカウント名</label>
          {user.accountName}
        </div>
        <div className="field">
          <label className="label">氏名</label>
          {user.name}
        </div>
      </section>
      <section className="modal-card-foot">
        <button
          type="button"
          className="button is-fullwidth is-failure"
          onClick={onCancel}
        >
          {cancelLabel}
        </button>
        <button
          className={classNames("button is-info is-fullwidth", {
            "is-loading": isLoading,
          })}
          onClick={onSubmit}
          disabled={isLoading}
        >
          {submitLabel}
        </button>
      </section>
    </>
  );
};
